export const formatLabel = (label) => {
  //first char of every word to uppercase
  const labelArray = label.split(' ');
  return labelArray
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    })
    .join(' ');
};
